import React, { useState, useEffect, useRef } from "react";
import "../../style.css";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Team01 } from "../../../../assets/images/team01.svg";
import { ReactComponent as GreenDot } from "../../../../assets/images/greendot.svg";
import { ReactComponent as EmptyUserIcon } from "../../../../assets/images/emptyUserIcon.svg";
import { ReactComponent as RedDot } from "../../../../assets/images/reddot.svg";
import { ReactComponent as GreyDot } from "../../../../assets/images/greydot.svg";
import SearchInput from "../../../common/SearchInputField";
import ButtonMain from "../../../common/ButtonMain";
import { ListCoRoleName } from "../../../../store/features/ListCoUserByRole";
import { deleteUserApi } from "../../../../store/features/deleteCoUser";
import DeletePopUp from "../../DeletePopUp";
import { suspendUserApi } from "../../../../store/features/suspendCoUser";
import TeamSideBar from "../TeamSideBar";
import Loader from "../../../../assets/Loader";
import { BASE_URL } from "../../../../api/ApiConfig";
import { createAppSocket } from '../../../../api/createAppSocket';
import { useSocket } from "../../../../SocketContext";
import {
  getTeamMgmtPeek,
  setTeamMgmtPeek,
  TEAM_MGMT_CACHE_TABS,
} from "../../../../utils/teamManagementViewCache";

const ENDPOINT = `${BASE_URL}`;

const chracterPosition = (alphabet) => {
  const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};
const colorCodesForAvatar = [
  "#405261", // A
  "#FF4D4F", // B
  "#FA541C", // C
  "#FA8C16", // D
  "#FAAD14", // E
  "#EB2F96", // F
  "#FADB14", // G
  "#A0D911", // H
  "#52C41A", // I
  "#5CDBD3", // J
  "#9254DE", // K
  "#F759AB", // L
  "#2F54EB", // M
  "#722ED1", // N
  "#1890FF", // O
  "#13C2C2", // P
  "#2DB7F5", // Q
  "#19BE6B", // R
  "#30A745", // S
  "#FA8C16", // T
  "#FAAD14", // U
  "#9254DE", // V
  "#F759AB", // W
  "#13C2C2", // X
  "#722ED1", // Y
  "#2DB7F5", // Z
];

function buildSupervisorRowsFromApiData(data) {
  if (!Array.isArray(data) || !data.length) return [];
  const outputarray = [];
  data.forEach((item) => {
    const userAvatars = item.groups.map((user) => {
      const firstLetter = user.title.charAt(0).toUpperCase();
      return <Avatar key={user._id}>{firstLetter}</Avatar>;
    });
    outputarray.push({
      id: item?._id,
      img: item?.agent_image,
      name: item?.full_name,
      email: item?.email,
      group: userAvatars,
      selected: false,
      ActiveUser: item?.is_joined ? "Active" : "Invite Send",
      DotColor: item?.is_joined ? <GreenDot /> : <GreyDot />,
      menu: "...",
    });
  });
  return outputarray;
}

function SuperVisorMain(props) {
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;
  const supPeek = getTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.SUPERVISORS);
  const initialSupervisorRows =
    supPeek?.rawData !== undefined
      ? buildSupervisorRowsFromApiData(supPeek.rawData)
      : [];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isActiveMenu, setIsActiveMenu] = useState(false);
  const [selectedActiveRow, setSelectedActiveRow] = useState(null);
  const [visibleRows, setVisibleRows] = useState(10);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(initialSupervisorRows);
  const [deleteUser, setDeleteUser] = useState(false);
  const [activeSidebar, setActiveSideBar] = useState(false);
  const [data, setData] = useState(initialSupervisorRows);
  const [getUserList, setGetUserList] = useState([]);

  const [teamUserId, setTeamUserId] = useState("");
  const [activeRowId, setActiveRowId] = useState(null);
  const [isLoading, setIsLoading] = useState(supPeek?.rawData === undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uID = userData.response?.user?._id;
  const uRole = userData.response?.user?.role_name;

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );

  const { setActiveChatLimit, setChatLimitDetail } = props;

  const handleViewMore = () => {
    setVisibleRows(visibleRows + 10);
  };

  const handleRowClick = (row) => {
    setActiveSideBar(row.id);
    setActiveRowId(row.id);
    setGetUserList(row);
  };

  const toggleMenu = (rowId) => {
    setSelectedRowId(rowId);
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleActiveMenu = (rowId) => {
    setIsActiveMenu(!isActiveMenu);
    setSelectedActiveRow(rowId);
  };
  const capitalize = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
      match.toUpperCase()
    );

  const RoleCoSupervisor = async () => {
    const listCoUserList = dispatch(
      ListCoRoleName({
        name: "supervisor",
      })
    );
    listCoUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
        } else if (data?.payload?.status === 200) {
          const list = Array.isArray(data.payload.data) ? data.payload.data : [];
          if (businessId) {
            setTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.SUPERVISORS, list);
          }
          const rows = buildSupervisorRowsFromApiData(list);
          setData(rows);
          setFilteredData(rows);
          setIsLoading(false);
        } else if (data?.payload?.status === 500) {
          setIsLoading(false);
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 401) {
          setIsLoading(false);
          toast.error("Login Expired. Please login  and try again.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/login");
        }
      })
      .catch(async (error) => {
        setIsLoading(false);
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const socketRef = useRef();

  useEffect(() => {
    socketRef.current = createAppSocket();

    return () => {
      // socketRef.current.disconnect();
    };
  }, []);

  useEffect(() => {
    RoleCoSupervisor();
  }, []);

  const deleteUserHandler = async () => {
    const deleteuserList = dispatch(
      deleteUserApi({
        requestHeaders: { id: teamUserId },
      })
    );
    deleteuserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data.payload.status === 200) {
          toast.success(data?.payload?.message);
          RoleCoSupervisor();
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const suspendUserHandler = async (rowID) => {
    const suspendUserList = dispatch(
      suspendUserApi({
        requestHeaders: { id: rowID },
      })
    );
    suspendUserList
      .then(async (data) => {
        if (typeof data.payload === "undefined") {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          if (props.setSupervisorCountLength) {
            props.setSupervisorCountLength((prevCount) =>
              Math.max(0, prevCount - 1)
            );
          }

          setTimeout(() => {
            setIsMenuOpen(false);
            setSelectedRowId(null);
            setFilteredData([]);
            setData([]);
            setIsLoading(true);
            RoleCoSupervisor();
          }, 500);
        } else if (data?.payload?.status === 500) {
          toast.error("Some Error Occured. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredResults = data.filter(
      (row) =>
        row.name.toLowerCase().includes(query) ||
        row.email.toLowerCase().includes(query)
    );

    setFilteredData(filteredResults);
  };
  const handleButtonClick = (userId) => {
    const url = `/userupdate/${userId}`;
    navigate(url);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>

      <div className="inviteButton-container">
        <SearchInput
          title=""
          placeholder="Search"
          className="SearchInput-teamsection"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
      </div>
      <div className="Team-Section-Content-Container">
        {parseInt(filteredData?.length) < 1 ? (
          <div className="NoSuspendedAgent-main-Conatiner">
            <div className="TeamChatBot-Main-Container">
              <EmptyUserIcon />
              <p className="Chatbot-devploment">{t.NOAVAILABLEUSERS}</p>
              <p className="Chatbot-crafting">{t.NOAVAILABLEUSERSMSG}</p>
            </div>
          </div>
        ) : (
          <>
            <p className="Team-total-active-user">Active (14)</p>
            <table className="Team-main-table-container">
              <thead>
                <tr className="table-header-cell">
                  <th>{t.NAMETB}</th>
                  <th>{t.EMAILTB}</th>
                  <th>{t.GROUPS}</th>
                  <th>{t.STATUSTB}</th>
                </tr>
              </thead>
              <tbody className="tbodyClass01">
                {filteredData.slice(0, visibleRows).map((row) => (
                  <tr key={row.id} className="team-table-tr">
                    <td
                      onClick={() => {
                        handleRowClick(row);
                      }}
                    >
                      <div>
                        <div className="team-table-img">
                          <p>
                            {row.img ? (
                              <Avatar
                                src={row.img}
                                alt="users logo"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <Avatar
                                sx={{
                                  bgcolor:
                                    colorCodesForAvatar[
                                    chracterPosition(
                                      row.name.substring(0, 1).toUpperCase()
                                    )
                                    ],
                                }}
                              >
                                {row.name.substring(0, 1).toUpperCase()}
                              </Avatar>
                            )}
                          </p>
                          <div>
                            <p className="team-table-rowtext">
                              {capitalize(row.name)}
                            </p>
                            <p>{row.member}</p>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      onClick={() => {
                        handleRowClick(row);
                      }}
                    >
                      {row.email}
                    </td>
                    <td>
                      <p className="groupIcon">
                        <AvatarGroup>{row.group}</AvatarGroup>
                      </p>
                    </td>
                    <td>
                      <div
                        className="team-activeuser"
                        onClick={() => {
                          toggleActiveMenu(row.id);
                          setIsMenuOpen(false);
                        }}
                      >
                        {row.DotColor}
                        {row.ActiveUser}
                        {row.DownLogo}
                      </div>
                      <div
                        onClick={() => {
                          toggleActiveMenu(row.id);
                          setIsMenuOpen(false);
                        }}
                      >
                        {isActiveMenu && selectedActiveRow === row.id && (
                          <div className="dropdown-content-table">
                            <ul>
                              <li
                                onClick={() => setIsActiveMenu(false)}
                                className="team-activeuser"
                              >
                                <GreenDot />
                                {t.ACCEPTCHAT}
                              </li>
                              <li className="team-activeuser">
                                <RedDot />
                                {t.NOTACCEPT}
                              </li>

                              <li className="team-activeuser">
                                <GreyDot />
                                {t.LOGOUT}
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      {uRole === "admin" ||
                        uRole === "admin_with_billing" ||
                        row.id === uID ? (
                        <p
                          className="team-table-menu"
                          onClick={() => {
                            setIsActiveMenu(false);
                            setIsMenuOpen(true);
                            toggleMenu(row.id);
                          }}
                        >
                          {row.menu}
                        </p>
                      ) : (
                        <p className="team-table-menu">{"   "}</p>
                      )}
                      {isMenuOpen && selectedRowId === row.id && (
                        <div className="dropdown-content-table">
                          <ul>
                            <li onClick={() => handleButtonClick(row.id)}>
                              {t.EDITPROFILE}
                            </li>
                            <li
                              onClick={() => {
                                setChatLimitDetail({
                                  id: row?.id,
                                  name: row?.name,
                                  email: row?.email,
                                  img: row?.img,
                                });
                                setActiveChatLimit(true);
                                setIsMenuOpen(false);
                              }}
                            >
                              {t.CHANGECHAT}
                            </li>
                            <li onClick={() => setIsMenuOpen(false)}>
                              {t.VIEWAGENT}
                            </li>
                            {uRole === "admin" ||
                              (uRole === "admin_with_billing" && (
                                <>
                                  <li
                                    onClick={() => suspendUserHandler(row.id)}
                                  >
                                    Suspend supervisor
                                  </li>
                                  <li
                                    onClick={() => {
                                      setTeamUserId(row.id);
                                      setDeleteUser(row.id);
                                    }}
                                  >
                                    {t.DELETEALL}
                                  </li>
                                </>
                              ))}
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
        <div className="TableView">
          {visibleRows < data.length && (
            <p className="view-more-text" onClick={handleViewMore}>
              {t.VIEWMO}
            </p>
          )}
        </div>
      </div>
      {deleteUser && (
        <DeletePopUp
          onCancel={() => setDeleteUser(false)}
          onDelete={() => {
            deleteUserHandler();
            setDeleteUser(false);
          }}
        />
      )}
      {activeSidebar && (
        <>
          <div className="overlay" />
          <TeamSideBar
            onCancel={() => setActiveSideBar(false)}
            onOpen={() => {
              setActiveSideBar(true);
            }}
            userList={getUserList}
          />
        </>
      )}
    </>
  );
}

export default SuperVisorMain;
